module.exports = __webpack_public_path__ + "fonts/Firasansregular.woff2";